import React from 'react';
import { UPSERT_INCOME_FORM_ID } from '../../components/UpsertIncomeModal/UpsertIncomeModal.meta';
import { IncomeData } from '../../useIncome';
import { IncomeModel } from '../../api/useIncomeQuery';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';
import { RealEstateEmpty } from '../../tables/RealEstate/RealEstate.empty';
import { useRealEstateForm } from './useRealEstateForm';
import { RealEstateFormFields } from './RealEstateFormFields';

export interface Props {
  clientId: string;
  income: IncomeModel | null;
  data: IncomeData;
  onSuccess: () => void;
  workflowProps?: WorkflowComponentProps;
}

export const RealEstateForm = ({ clientId, income, data, onSuccess, workflowProps }: Props) => {
  const {
    data: { formBag, defaultShowAdvanced, mutationBag },
    actions: { onSubmit },
  } = useRealEstateForm({ clientId, income, onSuccess, data });

  const { Options: options } = data;
  const { RealEstateAssetOptions } = options;

  if (RealEstateAssetOptions.length === 0) {
    return <RealEstateEmpty clientId={clientId} workflowProps={workflowProps} />;
  }

  return (
    <form
      onSubmit={onSubmit}
      id={UPSERT_INCOME_FORM_ID}
      css={`
        display: flex;
        flex-direction: column;
        gap: 16px;
      `}
      aria-label="Real Estate income form"
    >
      {mutationBag.error && (
        <Alert
          variant="error"
          message={mutationBag.error.message}
          onRequestClose={mutationBag.reset}
        />
      )}

      <RealEstateFormFields
        formBag={formBag}
        options={data.Options}
        defaultShowAdvanced={defaultShowAdvanced}
      />
    </form>
  );
};
